import React from 'react';
import { Archive, Clock, Gift, Star } from 'lucide-react';

export interface ArchivedBounty {
  id: string;
  title: string;
  description: string;
  reward: number;
  points: number;
  completedDate: string;
  winner: {
    username: string;
    walletAddress: string;
  };
  difficulty: 'Easy' | 'Medium' | 'Hard';
  totalSubmissions: number;
}

export const ARCHIVED_BOUNTIES: ArchivedBounty[] = [
  {
    id: 'SWORD-001',
    title: 'Gather dTAO CT KOL Information',
    description: 'In an effort to further our subnet mindshare analytics, your task is to compile a list of Twitter handles for prominent dTAO key opinion leaders (KOLs) to facilitate access to industry insights, trends, and discussions. This list should include influential figures such as researchers, developers, analysts, and accounts with an overall voice and following centered around dTAO. By curating these handles, we can gather engagement insight, stay informed on strategic developments, and ensure timely access to expert perspectives in the decentralized space.',
    reward: 500,
    points: 50,
    completedDate: '2025-03-04',
    winner: {
      username: 'cryptowhisperer',
      walletAddress: '0x1234...5678'
    },
    difficulty: 'Easy',
    totalSubmissions: 42
  }
];

export default function BountyArchive() {
  return (
    <div className="space-y-6">
      <div className="bg-black/40 backdrop-blur-sm rounded-xl shadow-2xl p-4 md:p-8 border border-white/10">
        <div className="flex items-center space-x-3 mb-6">
          <Archive className="w-8 h-8 text-red-600" />
          <h1 className="text-2xl md:text-3xl font-bold">Bounty Archive</h1>
        </div>

        <div className="space-y-4">
          {ARCHIVED_BOUNTIES.map((bounty) => (
            <div key={bounty.id} className="bg-black/20 backdrop-blur-sm rounded-lg p-6 border border-white/5">
              <div className="flex justify-between items-start mb-4">
                <div>
                  <h2 className="text-xl font-bold mb-2">{bounty.title}</h2>
                  <div className="flex items-center space-x-4 text-sm">
                    <span className="text-gray-400">
                      <Clock className="w-4 h-4 inline mr-1" />
                      Completed {new Date(bounty.completedDate).toLocaleDateString()}
                    </span>
                    <span className="text-green-400 font-medium">
                      {bounty.difficulty}
                    </span>
                  </div>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="flex items-center text-yellow-400 bg-yellow-400/10 px-3 py-1 rounded-lg">
                    <Star className="w-4 h-4 mr-1" />
                    <span>{bounty.points} Points</span>
                  </div>
                  <div className="flex items-center text-green-400 bg-green-400/10 px-3 py-1 rounded-lg">
                    <Gift className="w-4 h-4 mr-1" />
                    <span>{bounty.reward} USDC</span>
                  </div>
                </div>
              </div>

              <p className="text-gray-300 mb-4">{bounty.description}</p>

              <div className="flex justify-between items-center pt-4 border-t border-white/10">
                <div className="text-sm text-gray-400">
                  Winner: <span className="text-white">{bounty.winner.username}</span>
                </div>
                <div className="text-sm text-gray-400">
                  Total Submissions: <span className="text-white">{bounty.totalSubmissions}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}